import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "../../Generic/Button";
import Card from "../../Generic/Card";
import CookBookConnector from "../Connector/CookBookConnector";
import { errorNotification } from "../../Generic/Notifications";
import Loader from "../../Generic/Loader";
import EmptyState from "../../Generic/EmptyState";
import { beautifyKey, convertTime } from "../../util/util";
import { useNavigate, useParams } from "react-router-dom";
import StudioService from "../Services/StudioService";
import useQuery from "../../util/hooks/useQuery";
import { ReverseDispenseType, ReverseDispensePatternType } from "../Reducer";

const Page = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0 1rem 1rem 1rem;
`;

const Header = styled.div`
	display: flex;
	justify-content: flex-start;
	font-size: 2.3rem;
	margin: ${(props) => props.margin};
	width: 100%;
`;

const Div = styled.div`
	position: ${(props) => props.position};
	width: ${(props) => props.width};
	display: flex;
	flex-direction: ${(props) => props.flexDirection};
	flex-wrap: ${(props) => props.flexWrap};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
	font-size: ${(props) => props.fontSize};
	font-family: ${(props) => props.fontFamily};
	@media (max-width: 1000px) {
		justify-content: ${(props) => props.jContentBefore1000};
	}
`;

const Span = styled.span`
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	font-family: ${(props) => props.fontFamily};
	color: ${(props) => props.color};
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
	text-align: ${(props) => props.textAlign};
`;

const Img = styled.img`
	height: ${(props) => props.height};
	width: ${(props) => props.width};
`;

const Tag = styled.div`
	background: #fff;
	border-radius: 3px 0 0 3px;
	color: #000;
	display: inline-block;
	height: 26px;
	line-height: 26px;
	padding: 0 20px 0 20px;
	position: relative;
	margin: 0 10px 10px 0;
	text-decoration: none;
	-webkit-transition: color 0.2s;
	font-size: 13px;

	&:after {
		background: #eee;
		border-bottom: 13px solid transparent;
		border-left: 10px solid #fff;
		border-top: 13px solid transparent;
		content: "";
		position: absolute;
		right: 0;
		top: 0;
	}
`;

const IngredientDetails = (props) => {
	const { id } = useParams();
	const pageQuery = useQuery();
	const { selectedIngredient } = props;
	const initialLoading = pageQuery.get("action") === "noReload" ? false : true;
	const [loading, setLoading] = useState(initialLoading);
	const [error, setError] = useState(false);
	const navigate = useNavigate();

	function renderIngredient(ingredient) {
		return (
			<>
				<Card background="" padding="0 0 2rem 0" margin="0rem 0 0 0" width="100%" alignItem="center">
					<Div width="100%" alignItem="center" padding="0 3rem">
						<Div flexDirection="column" jContent="" alignItem="">
							<Header>{ingredient?.name || beautifyKey(id)}</Header>
							<Div jContent="space-between" width="100%" margin="1rem 0 0 0">
								{ingredient?.isBaseItem ? <Tag>Base Item</Tag> : ""}
								{/* {props.DispenserTypes.hasOwnProperty(ingredient.dispenseDetails?.dispenserType) ? (
									<Tag>{props.DispenserTypes[ingredient.dispenseDetails.dispenserType]}</Tag>
								) : (
									""
								)} */}
							</Div>
						</Div>
					</Div>
					<Div flexDirection="column" padding="1rem 3rem 0 3rem" width="100%">
						<Span fontWeight="600" margin="0.5rem 0 0 0">
							{ingredient?.description ?? "\xa0 -"}
						</Span>
					</Div>
					<Div width="100%" flexWrap="wrap" padding="1rem 1.5rem">
						<Card border="1px solid rgba(0,0,0,0.4)" margin="1rem 1.5rem" padding="1rem 0 2rem 0" flexDirection="column">
							<Div width="100%" jContent="center" fontSize="1.2rem">
								Metadata
							</Div>
							<Div jContent="center" width="100%" alignItem="center" flexWrap="wrap">
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Type</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.ingredientType ? ingredient.ingredientType : "\xa0 -"}
									</Span>
								</Div>
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Default Serving Temp</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.defaultServingTemp ? ingredient.defaultServingTemp : "\xa0 -"}
									</Span>
								</Div>
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Calories Per Gram</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.dietaryDetails?.caloriesPerGram ? ingredient.dietaryDetails.caloriesPerGram : "\xa0 -"}
									</Span>
								</Div>
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Protein Per Gram</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.dietaryDetails?.proteinPerGram ? ingredient.dietaryDetails.proteinPerGram : "\xa0 -"}
									</Span>
								</Div>
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Fibre Per Gram</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.dietaryDetails?.fibrePerGram ? ingredient.dietaryDetails.fibrePerGram : "\xa0 -"}
									</Span>
								</Div>
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Allergens</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.dietaryDetails?.allergens?.length
											? JSON.stringify(ingredient.dietaryDetails.allergens)
											: "\xa0 -"}
									</Span>
								</Div>
							</Div>
						</Card>
						<Card border="1px solid rgba(0,0,0,0.4)" margin="1rem 1.5rem" padding="1rem 0 2rem 0" flexDirection="column">
							<Div width="100%" jContent="center" fontSize="1.2rem">
								Expiry time
							</Div>
							<Div jContent="center" width="100%" alignItem="center" flexWrap="wrap">
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Room</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.expiresInMinutes?.room ? convertTime(ingredient.expiresInMinutes.room) : "\xa0 -"}
									</Span>
								</Div>
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Refrigerated</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.expiresInMinutes?.refrigerated
											? convertTime(ingredient.expiresInMinutes.refrigerated)
											: "\xa0 -"}
									</Span>
								</Div>
							</Div>
						</Card>
						<Card border="1px solid rgba(0,0,0,0.4)" margin="1rem 1.5rem" padding="1rem 0 2rem 0" flexDirection="column">
							<Div width="100%" jContent="center" fontSize="1.2rem">
								Fill Details
							</Div>
							<Div jContent="center" width="100%" alignItem="center" flexWrap="wrap">
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Fill</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.inventoryData?.fillDetails?.fillAmount ?? "\xa0 -"}
									</Span>
								</Div>
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Max Fill</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.inventoryData?.fillDetails?.maxAmount ?? "\xa0 -"}
									</Span>
								</Div>
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Wastage</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.inventoryData?.fillDetails?.wasteAmount ?? "\xa0 -"}
									</Span>
								</Div>
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Threshold Percentage</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.inventoryData?.fillDetails?.inventoryThresholdPercentage ?? "\xa0 -"}
									</Span>
								</Div>
							</Div>
						</Card>
						<Card border="1px solid rgba(0,0,0,0.4)" margin="1rem 1.5rem" padding="1rem 1rem 2rem 1rem" flexDirection="column">
							<Div width="100%" jContent="center" fontSize="1.2rem">
								Landing Time
							</Div>
							<Div jContent="center" width="100%" alignItem="center" flexWrap="wrap">
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Floor 0</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.inventoryData?.dispenseDetails?.landingTime?.floor0 ?? "\xa0 -"}
									</Span>
								</Div>
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Floor 1</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.inventoryData?.dispenseDetails?.landingTime?.floor1 ?? "\xa0 -"}
									</Span>
								</Div>
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Floor 2</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.inventoryData?.dispenseDetails?.landingTime?.floor2 ?? "\xa0 -"}
									</Span>
								</Div>
							</Div>
						</Card>
						<Card border="1px solid rgba(0,0,0,0.4)" margin="1rem 1.5rem" padding="1rem 0 2rem 0" flexDirection="column">
							<Div width="100%" jContent="center" fontSize="1.2rem">
								RPM Constraints
							</Div>
							<Div width="100%" alignItem="center" flexWrap="wrap">
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Min RPM</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.inventoryData?.dispenseDetails?.rpmConstraints[0] ?? "\xa0 -"}
									</Span>
								</Div>
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span color="rgba(0,0,0,0.6)">Max RPM</Span>
									<Span fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.inventoryData?.dispenseDetails?.rpmConstraints[1] ?? "\xa0 -"}
									</Span>
								</Div>
							</Div>
						</Card>
						<Card border="1px solid rgba(0,0,0,0.4)" margin="1rem 1.5rem" padding="1rem 0 2rem 0" flexDirection="column">
							<Div width="100%" jContent="center" fontSize="1.2rem">
								Dispense Details
							</Div>
							<Div jContent="center" width="100%" alignItem="center" flexWrap="wrap">
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span textAlign="center" color="rgba(0,0,0,0.6)">
										Agitation Required
									</Span>
									<Span textAlign="center" fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.inventoryData?.dispenseDetails?.agitationRequired ? "Yes" : "No"}
									</Span>
								</Div>
                                <Div flexDirection="column" padding="1rem 1rem 0 1rem">
                                    <Span textAlign="center" color="rgba(0,0,0,0.6)">Dispense Type</Span>
                                    <Span textAlign="center" fontWeight="600" margin="0.5rem 0 0 0">
                                        {ingredient?.inventoryData?.dispenseDetails?.dispenseType ? ReverseDispenseType[ingredient?.inventoryData?.dispenseDetails?.dispenseType] : "\xa0 -"}
                                    </Span>
                                </Div>
							<Div flexDirection="column" padding="1rem 1rem 0 1rem">
								<Span textAlign="center" color="rgba(0,0,0,0.6)">Dispense Pattern Type</Span>
								<Span textAlign="center" fontWeight="600" margin="0.5rem 0 0 0">
									{ingredient?.inventoryData?.dispenseDetails?.dispensePatternType ? ReverseDispensePatternType[ingredient?.inventoryData?.dispenseDetails?.dispensePatternType] : "\xa0 -"}
								</Span>
							</Div>
                                {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.constant !== undefined && ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.constant !== null ? (
                                    <Div flexDirection="column" padding="1rem 1rem 0 1rem">
                                        <Span color="rgba(0,0,0,0.6)">Constant</Span>
                                        <Span fontWeight="600" margin="0.5rem 0 0 0">
                                            {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.constant}
                                        </Span>
                                    </Div>
                                ) : (
                                    ""
                                )}
                                {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingRate !== undefined && ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingRate !== null ? (
                                    <Div flexDirection="column" padding="1rem 1rem 0 1rem">
                                        <Span color="rgba(0,0,0,0.6)">Rate</Span>
                                        <Span fontWeight="600" margin="0.5rem 0 0 0">
                                            {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingRate}
                                        </Span>
                                    </Div>
                                ) : (
                                    ""
                                )}
                                {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.backRotation !== undefined && ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.backRotation !== null ? (
                                    <Div flexDirection="column" padding="1rem 1rem 0 1rem">
                                        <Span color="rgba(0,0,0,0.6)">Back Rotation</Span>
                                        <Span textAlign="center" fontWeight="600" margin="0.5rem 0 0 0">
                                            {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.backRotation}
                                        </Span>
                                    </Div>
                                ) : (
                                    ""
                                )}
                                {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.backRotationRPM !== undefined && ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.backRotationRPM !== null ? (
                                    <Div flexDirection="column" padding="1rem 1rem 0 1rem">
                                        <Span color="rgba(0,0,0,0.6)">Back Rotation RPM</Span>
                                        <Span textAlign="center" fontWeight="600" margin="0.5rem 0 0 0">
                                            {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.backRotationRPM}
                                        </Span>
                                    </Div>
                                ) : (
                                    ""
                                )}
                                {/* To and Fro Dispense Parameters (optional) */}
                                {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleForwardDegrees !== undefined && ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleForwardDegrees !== null ? (
                                    <Div flexDirection="column" padding="1rem 1rem 0 1rem">
                                        <Span color="rgba(0,0,0,0.6)">Forward Dispense Degrees</Span>
                                        <Span fontWeight="600" margin="0.5rem 0 0 0">
                                            {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleForwardDegrees}
                                        </Span>
                                    </Div>
                                ) : (
                                    ""
                                )}
                                {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleForwardRpm !== undefined && ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleForwardRpm !== null ? (
                                    <Div flexDirection="column" padding="1rem 1rem 0 1rem">
                                        <Span color="rgba(0,0,0,0.6)">Forward Dispense RPM</Span>
                                        <Span fontWeight="600" margin="0.5rem 0 0 0">
                                            {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleForwardRpm}
                                        </Span>
                                    </Div>
                                ) : (
                                    ""
                                )}
                                {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleBackwardDegrees !== undefined && ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleBackwardDegrees !== null ? (
                                    <Div flexDirection="column" padding="1rem 1rem 0 1rem">
                                        <Span color="rgba(0,0,0,0.6)">Backward Dispense Degrees</Span>
                                        <Span fontWeight="600" margin="0.5rem 0 0 0">
                                            {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleBackwardDegrees}
                                        </Span>
                                    </Div>
                                ) : (
                                    ""
                                )}
                                {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleBackwardRpm !== undefined && ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleBackwardRpm !== null ? (
                                    <Div flexDirection="column" padding="1rem 1rem 0 1rem">
                                        <Span color="rgba(0,0,0,0.6)">Backward Dispense RPM</Span>
                                        <Span fontWeight="600" margin="0.5rem 0 0 0">
                                            {ingredient?.inventoryData?.dispenseDetails?.dispenseConfig?.dispensingCycleBackwardRpm}
                                        </Span>
                                    </Div>
                                ) : (
                                    ""
                                )}
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span textAlign="center" color="rgba(0,0,0,0.6)">
										Prime Rotation Count
									</Span>
									<Span textAlign="center" fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.inventoryData?.dispenseDetails?.primeRotationCount ?? "\xa0 -"}
									</Span>
								</Div>
								<Div flexDirection="column" padding="1rem 1rem 0 1rem">
									<Span textAlign="center" color="rgba(0,0,0,0.6)">
										Accuracy Buffer
									</Span>
									<Span textAlign="center" fontWeight="600" margin="0.5rem 0 0 0">
										{ingredient?.inventoryData?.dispenseDetails?.accuracyBuffer ?? "\xa0 -"}
									</Span>
								</Div>
								{ingredient?.inventoryData?.dispenseDetails?.dispenserConfig ? (
									<>
										<Div flexDirection="column" padding="1rem 1rem 0 1rem">
											<Span color="rgba(0,0,0,0.6)">Container Type</Span>
											<Span textAlign="center" fontWeight="600" margin="0.5rem 0 0 0">
												{ingredient?.inventoryData?.dispenseDetails?.dispenserConfig?.containerType ?? "\xa0 -"}
											</Span>
										</Div>
										<Div flexDirection="column" padding="1rem 1rem 0 1rem">
											<Span textAlign="center" color="rgba(0,0,0,0.6)">
												Base Type
											</Span>
											<Span textAlign="center" fontWeight="600" margin="0.5rem 0 0 0">
												{ingredient?.inventoryData?.dispenseDetails?.dispenserConfig?.baseType ?? "\xa0 -"}
											</Span>
										</Div>
										<Div flexDirection="column" padding="1rem 1rem 0 1rem">
											<Span textAlign="center" color="rgba(0,0,0,0.6)">
												Spout Type
											</Span>
											<Span textAlign="center" fontWeight="600" margin="0.5rem 0 0 0">
												{ingredient?.inventoryData?.dispenseDetails?.dispenserConfig?.spoutType ?? "\xa0 -"}
											</Span>
										</Div>
									</>
								) : (
									""
								)}
							</Div>
						</Card>
					</Div>
				</Card>
			</>
		);
	}

	async function FetchIngredient() {
		if (pageQuery.get("action") === "noReload") return;

		setLoading(true);
		setError(false);

		const response = await StudioService.getIngredientData(id);
		const { data, error } = response;
		if (data) {
			props.getIngredient(data[0]);
			setLoading(false);
			setError(false);
		}
		if (error) {
			setLoading(false);
			setError(true);
			errorNotification(error);
		}
	}

	useEffect(() => {
		FetchIngredient();
	}, []);

	return (
		<Page>
			<Div padding="1rem 0" width="100%" jContent="space-between" alignItem="center">
				<span onClick={() => navigate("/studio/ingredient")} className="material-symbols-outlined" style={{ cursor: "pointer" }}>
					arrow_back
				</span>
				{!loading && !error ? (
					<Button
						onClick={() => {
							props.changeEditMode({ objectToEdit: selectedIngredient });
							navigate(`/studio/ingredient/${id}/edit`);
						}}>
						Edit
					</Button>
				) : (
					""
				)}
			</Div>
			{loading ? <Loader /> : ""}
			{error ? <EmptyState retry={FetchIngredient} /> : ""}
			{!loading && !error ? renderIngredient(selectedIngredient) : ""}
		</Page>
	);
};

export default CookBookConnector(IngredientDetails);
